import React from "react";
import { useHistory } from "react-router-dom";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";

export const BalanceGeneralItem = ({ data }) => {
  const history = useHistory();
  const handleClickBalanceGeneral = () => {
    history.push("/Finanzas/BalanceGeneral");
  };

  const formatmiles = (number) => {
    return Math.floor((number ?? 0) / 1000).toLocaleString('en-US');
  };


  const efectivo = data?.balancegeneral?.find(item => item.nivel3 === 'EFECTIVO')?.total ?? 0;
  const inversiones = data?.balancegeneral?.find(item => item.nivel3 === 'INVERSIONES').total ?? 0;
  const clientes = data?.balancegeneral?.find(item => item.nivel3 === 'CLIENTES').total ?? 0;
  const inventarios = data?.balancegeneral?.find(item => item.nivel3 === 'INVENTARIOS').total ?? 0;
  const otrosActivos = data?.balancegeneral?.find(item => item.nivel3 === 'OTROS ACTIVOS').total ?? 0;
  const activoFijo = data?.balancegeneral?.find(item => item.nivel3 === 'ACTIVO FIJO').total ?? 0;
  const depreciacion = data?.balancegeneral?.find(item => item.nivel3 === 'DEPRECIACION').total ?? 0;
  const pasivocortoplazo = data?.balancegeneral?.find(item => item.nivel3 === 'CORTO PLAZO').total ?? 0;
  const acreedores = data?.balancegeneral?.find(item => item.nivel3 === 'ACREEDORES DIVERSOS').total ?? 0;
  const pasivolargoplazo = data?.balancegeneral?.find(item => item.nivel3 === 'LARGO PLAZO').total ?? 0;
  const capitalcontable = data?.balancegeneral?.find(item => item.nivel3 === 'CAPITAL CONTABLE').total ?? 0;

  return (
    <div className="dashboard-financiero-container-box" onClick={handleClickBalanceGeneral}>
      <div className="dashboard-financiero-container-box-titulo">
        Balance General
      </div>
      <div className="dashboard-financiero-container-box-info df_box_balance">
        <div className="df_box_balance_space-activo">
          <div className="df_box_balance_space-header">Activo Circulante</div>
          <div className="df_box_balance_item">
            <div>
              <ArrowRightIcon />
              Efectivo
            </div>
            <span> {formatmiles(efectivo)}</span>
          </div>
          <div className="df_box_balance_item df_box_balance_item_2n">
            <div>
              <ArrowRightIcon />
              Inversiones
            </div>
            <span> {formatmiles(inversiones)}</span>
          </div>
          <div className="df_box_balance_item">
            <div>
              <ArrowRightIcon />
              Clientes
            </div>
            <span> {formatmiles(clientes)}</span>
          </div>
          <div className="df_box_balance_item df_box_balance_item_2n">
            <div>
              <ArrowRightIcon />
              Inventarios
            </div>
            <span> {formatmiles(inventarios)}</span>
          </div>
          <div className="df_box_balance_item">
            <div>
              <ArrowRightIcon />
              Otros Activos
            </div>
            <span> {formatmiles(otrosActivos)}</span>
          </div>
          <div className="df_box_balance_space-header">
            Activo No Circulante
          </div>
          <div className="df_box_balance_item">
            <div>
              <ArrowRightIcon />
              Activo Fijo y Otros
            </div>
            <span>{formatmiles(activoFijo)}</span>
          </div>
          <div className="df_box_balance_item df_box_balance_item_2n">
            <div>
              <ArrowRightIcon />
              Depreciación
            </div>
            <span> {formatmiles(depreciacion)}</span>
          </div>
        </div>
        <div className="df_box_balance_space-pasivo">
          <div className="df_box_balance_space-pasivo-header">
            Pasivo y Capital
          </div>
          <div className="df_box_balance_space-pasivo-item ">
            <div>Pasivo Corto Plazo</div>
            <span>{formatmiles(pasivocortoplazo)}</span>
          </div>
          <div className="df_box_balance_space-pasivo-item df_box_balance_space-pasivo-item-2n">
            <div>Acreedores Diversos</div>
            <span>{formatmiles(acreedores)}</span>
          </div>
          <div className="df_box_balance_space-pasivo-item">
            <div>Pasivo Largo Plazo</div>
            <span>{formatmiles(pasivolargoplazo)}</span>
          </div>
          <div className="df_box_balance_space-pasivo-item df_box_balance_space-pasivo-item-2n">
            <div>Capital Contable</div>
            <span>{formatmiles(capitalcontable)}</span>
          </div>
        </div>
      </div>
    </div>
  );
};
